import {
  PartnerWorkerCla,
  PartnerWorkerClaScale,
} from 'partner/shared/services/partner-worker-service.types';

export type ClaTableRow = {
  key: string;
  claId: string;
  claName: string | null;
  claNameRowSpan?: number;
  scale: PartnerWorkerClaScale | null;
  scaleRowSpan?: number;
  step: string | null;
  startDate: string | null;
  endDate: string | null;
};

export const mapClasToForm = (clas: PartnerWorkerCla[]): ClaTableRow[] =>
  clas.flatMap((cla) => {
    if (cla.scales.length === 0) {
      return [
        {
          key: cla.id,
          claId: cla.id,
          claName: cla.name,
          claNameRowSpan: 1,
          scale: null,
          scaleRowSpan: 1,
          step: null,
          startDate: null,
          endDate: null,
        },
      ];
    }

    const claRowCount = cla.scales.reduce(
      (total, scale) => total + Math.max(1, scale.steps.length),
      0
    );

    let isFirstRow = true;
    return cla.scales.flatMap((scale, scaleIndex) => {
      const scaleRowSpan = Math.max(1, scale.steps.length);

      if (scale.steps.length === 0) {
        const row: ClaTableRow = {
          key: `${cla.id}:${scaleIndex}`,
          claId: cla.id,
          claName: isFirstRow ? cla.name : null,
          claNameRowSpan: isFirstRow ? claRowCount : undefined,
          scale,
          scaleRowSpan,
          step: null,
          startDate: null,
          endDate: null,
        };
        isFirstRow = false;
        return [row];
      }

      return scale.steps.map((step, stepIndex): ClaTableRow => {
        const isFirstStep = stepIndex === 0;
        const row: ClaTableRow = {
          key: `${cla.id}:${scaleIndex}:${stepIndex}`,
          claId: cla.id,
          claName: isFirstRow ? cla.name : null,
          claNameRowSpan: isFirstRow ? claRowCount : undefined,
          scale: isFirstStep ? scale : null,
          scaleRowSpan: isFirstStep ? scaleRowSpan : undefined,
          step: step.step,
          startDate: step.startDate,
          endDate: step.endDate ?? null,
        };
        isFirstRow = false;
        return row;
      });
    });
  });
